import { RouteConfig } from 'vue-router';

const Login = () => import(/* webpackChunkName: "Access" */  './views/login/login.vue');
const Forgot = () => import(/* webpackChunkName: "Access" */  './views/forgot/forgot.vue');



const routers: RouteConfig[] = [
    {
        path: 'login',
        name: 'login',
        component: Login
    },
    {
        path: "forgot",
        name: "forgot",
        component: Forgot
    },
    {
        path: '',
        redirect: 'login'
    },
];

export default routers;

